<template>
    <div>
        <div
            v-can:create="'application'"
            class="row justify-content-center mx-5 py-5">
            <st-button
                variant="secondary"
                :block="true"
                :callback="createRequest"
                id="btn_create_request"
                customClass="text-dark application-add-button"
            >
                <i class="fas fa-plus text-dark application-btn-icon"/>
                <span class="application-create-btn-text">{{ $t('MENU.CREATE_REQUEST_BUTTON') }}</span>
            </st-button>
        </div>
        <ul class="menu-nav custom-menu-nav">
            <!-- Root -->
            <!-- Dashboard menu item available after BE is done -->
            <router-link
                v-if="hasPermissionsToViewDashboard"
                v-slot="{ href, navigate, isActive, isExactActive }"
                to="/dashboard">
                <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                >
                    <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-icon fas fa-th-large"/>
                        <span :class="{ 'menu-header': hasPermissionsToViewReports}"
                              class="menu-text">{{ $t('MENU.DASHBOARD') }}</span>
                    </a>
                    <ul>
                        <li class="menu-item menu-item-submenu menu-item-open">
                            <div class="menu-submenu menu-submenu-classic menu-submenu-right ">
                                <ul v-if="hasPermissionsToViewReports" class="menu-subnav">
                                    <router-link
                                        to="/dashboard-reports"
                                        v-slot="{ href, navigate, isExactActive }"
                                    >
                                        <li
                                            aria-haspopup="true"
                                            data-menu-toggle="hover"
                                            class="menu-item"
                                            :class="[isExactActive && 'menu-item-active']"
                                            >
                                             <a :href="href" class="menu-link" @click="navigate">
                                                <i class="menu-icon fas fa-arrow-right"><span></span></i>
                                                <span class="menu-text"> {{ $t('MENU.DASHBOARD_REPORTS') }}</span>
                                            </a>
                                        </li>
                                    </router-link>
                                </ul>
                            </div>
                        </li>
                    </ul>
                </li>
            </router-link>
            <hr v-if="hasPermissionsToViewReports">
            <router-link
                v-can:read="'applications'"
                v-slot="{ href, navigate, isActive, isExactActive }"
                to="/applications">
                <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                >
                    <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-icon far fa-file"/>
                        <span class="menu-text menu-header">{{ $t('MENU.MY_APPLICATIONS') }}</span>
                    </a>
                    <ul>
                        <li class="menu-item menu-item-submenu menu-item-open">
                            <div class="menu-submenu menu-submenu-classic menu-submenu-right ">
                                <ul class="menu-subnav">
                                    <router-link
                                        v-can:read="'applications'"
                                        to="/applications-draft"
                                        v-slot="{ href, navigate, isExactActive }"
                                    >
                                        <li
                                            aria-haspopup="true"
                                            data-menu-toggle="hover"
                                            class="menu-item"
                                            :class="[isExactActive && 'menu-item-active']"
                                        >
                                            <a :href="href" class="menu-link" @click="navigate">
                                                <span class="menu-text">
                                                    {{ $t('MENU.DRAFT') }}
                                                </span>
                                                <span v-if="counts.draft !== null && counts.draft > 0" class="menu-text ml-auto d-flex justify-content-end flex-grow-0 pr-9">{{ counts.draft }}</span>
                                            </a>
                                        </li>
                                    </router-link>
                                    <router-link
                                        v-can:read="'applications'"
                                        to="/applications-submitted"
                                        v-slot="{ href, navigate, isExactActive }"
                                    >
                                        <li
                                            aria-haspopup="true"
                                            data-menu-toggle="hover"
                                            class="menu-item"
                                            :class="[isExactActive && 'menu-item-active']"
                                        >
                                            <a :href="href" class="menu-link" @click="navigate">
                                                <span class="menu-text">
                                                    {{ $t('MENU.SUBMITTED') }}
                                                </span>
                                                <span v-if="counts.submitted !== null && counts.submitted > 0" class="menu-text ml-auto d-flex justify-content-end flex-grow-0 pr-9">{{ counts.submitted }}</span>
                                            </a>
                                        </li>
                                    </router-link>
                                    <router-link
                                        v-can:read="'applications'"
                                        to="/applications-sign-pending"
                                        v-slot="{ href, navigate, isExactActive }"
                                    >
                                        <li
                                            aria-haspopup="true"
                                            data-menu-toggle="hover"
                                            class="menu-item"
                                            :class="[isExactActive && 'menu-item-active']"
                                        >
                                            <a :href="href" class="menu-link" @click="navigate">
                                                <span class="menu-text">
                                                    <span v-if="counts.sign_pending !== null && counts.sign_pending > 0" class="d-flex align-items-center">
                                                        <i class="fas fa-circle font-size-xs text-danger mr-2"></i>
                                                    </span>
                                                    {{ $t('MENU.SIGN_PENDING') }}
                                                </span>
                                                <span v-if="counts.sign_pending !== null && counts.sign_pending > 0" class="menu-text ml-auto d-flex justify-content-end flex-grow-0 pr-9">{{ counts.sign_pending }}</span>
                                            </a>
                                        </li>
                                    </router-link>                                    
                                    <router-link
                                        v-can:read="'applications'"
                                        to="/applications-clarifications"
                                        v-slot="{ href, navigate, isExactActive }"
                                    >
                                        <li
                                            aria-haspopup="true"
                                            data-menu-toggle="hover"
                                            class="menu-item"
                                            :class="[isExactActive && 'menu-item-active']"
                                        >
                                            <a :href="href" class="menu-link" @click="navigate">
                                                <span class="menu-text">
                                                    <span v-if="counts.clarifications !== null && counts.clarifications > 0" class="d-flex align-items-center">
                                                        <i class="fas fa-circle font-size-xs text-danger mr-2"></i>
                                                    </span>
                                                    {{ $t('MENU.TO_CLARIFY') }}
                                                </span>
                                                <span v-if="counts.clarifications !== null && counts.clarifications > 0" class="menu-text ml-auto d-flex justify-content-end flex-grow-0 pr-9">{{ counts.clarifications }}</span>
                                            </a>
                                        </li>
                                    </router-link>
                                    <router-link
                                        v-can:read="'applications'"
                                        to="/applications-finalized"
                                        v-slot="{ href, navigate, isExactActive }"
                                    >
                                        <li
                                            aria-haspopup="true"
                                            data-menu-toggle="hover"
                                            class="menu-item"
                                            :class="[isExactActive && 'menu-item-active']"
                                        >
                                            <a :href="href" class="menu-link" @click="navigate">
                                                <span class="menu-text">
                                                    {{ $t('MENU.FINALIZED') }}
                                                </span>
                                                <span v-if="counts.finalized !== null" class="menu-text ml-auto d-flex justify-content-end flex-grow-0 pr-9">{{ counts.finalized }}</span>
                                            </a>
                                        </li>
                                    </router-link>
                                </ul>
                            </div>
                        </li>
                    </ul>
                </li>
            </router-link>
            <router-link
                v-if="hasPermissionToViewApplications"
                v-slot="{ href, navigate, isActive, isExactActive }"
                to="/applications-inbox">
                <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                >
                    <a :href="href" class="menu-link" @click="(e) => onNavigateWithCountUpdate(e, navigate)">
                        <i class="menu-icon fas fa-sync"/>
                        <span class="menu-text menu-header">{{ $t('MENU.INBOX') }}</span>
                    </a>
                    <ul>
                        <li class="menu-item menu-item-submenu menu-item-open">
                            <div class="menu-submenu menu-submenu-classic menu-submenu-right ">
                                <ul class="menu-subnav">
                                    <router-link
                                        v-can:read="'applicationsStaffOwn'"
                                        to="/applications-assigned"
                                        v-slot="{ href, navigate, isExactActive }"
                                    >
                                        <li
                                            aria-haspopup="true"
                                            data-menu-toggle="hover"
                                            class="menu-item"
                                            :class="[
                                                isExactActive && 'menu-item-active'
                                            ]"
                                        >
                                            <a :href="href" class="menu-link" @click="(e) => onNavigateWithCountUpdate(e, navigate)">
                                                <span class="menu-text">
                                                    <span v-if="counts.assigned !== null && counts.assigned > 0" class="d-flex align-items-center">
                                                        <i class="fas fa-circle font-size-xs text-danger mr-2"></i>
                                                    </span>
                                                    {{ $t('MENU.STAFF_OWN_APPLICATIONS') }}
                                                </span>
                                                <span v-if="counts.assigned !== null && counts.assigned > 0" class="menu-text ml-auto d-flex justify-content-end flex-grow-0 pr-9">{{ counts.assigned }}</span>
                                            </a>
                                        </li>
                                    </router-link>
                                    <router-link
                                        v-can:read="'applicationsStaffOwn'"
                                        to="/applications-assigned-clarifications"
                                        v-slot="{ href, navigate, isExactActive }"
                                    >
                                        <li
                                            aria-haspopup="true"
                                            data-menu-toggle="hover"
                                            class="menu-item"
                                            :class="[
                                                isExactActive && 'menu-item-active'
                                            ]"
                                        >
                                            <a :href="href" class="menu-link" @click="(e) => onNavigateWithCountUpdate(e, navigate)">
                                                <span class="menu-text">
                                                    <span v-if="counts.assigned_clarifications !== null && counts.assigned_clarifications > 0" class="d-flex align-items-center">
                                                        <i class="fas fa-circle font-size-xs text-danger mr-2"></i>
                                                    </span>
                                                    {{ $t('MENU.STAFF_OWN_CLARIFICATIONS') }}
                                                </span>
                                                <span v-if="counts.assigned_clarifications !== null && counts.assigned_clarifications > 0" class="menu-text ml-auto d-flex justify-content-end flex-grow-0 pr-9">{{ counts.assigned_clarifications }}</span>
                                            </a>
                                        </li>
                                    </router-link>
                                    <router-link
                                        v-can:read="'applicationsStaffOwn'"
                                        to="/applications-review"
                                        v-slot="{ href, navigate, isExactActive }"
                                    >
                                        <li
                                            aria-haspopup="true"
                                            data-menu-toggle="hover"
                                            class="menu-item"
                                            :class="[
                                                isExactActive && 'menu-item-active'
                                            ]"
                                        >
                                            <a :href="href" class="menu-link" @click="(e) => onNavigateWithCountUpdate(e, navigate)">
                                                <span class="menu-text">
                                                    <span v-if="counts.to_review !== null && counts.to_review > 0" class="d-flex align-items-center">
                                                        <i class="fas fa-circle font-size-xs text-danger mr-2"></i>
                                                    </span>
                                                    {{ $t('MENU.STAFF_REVIEW_APPLICATIONS') }}
                                                </span>
                                                <span v-if="counts.to_review !== null && counts.to_review > 0" class="menu-text ml-auto d-flex justify-content-end flex-grow-0 pr-9">{{ counts.to_review }}</span>
                                            </a>
                                        </li>
                                    </router-link>                                    
                                    <router-link
                                        v-can:read="'applicationsStaffOwn'"
                                        to="/new-applications"
                                        v-slot="{ href, navigate, isExactActive }"
                                    >
                                        <li
                                            aria-haspopup="true"
                                            data-menu-toggle="hover"
                                            class="menu-item"
                                            :class="[
                                                isExactActive && 'menu-item-active'
                                            ]"
                                        >
                                            <a :href="href" class="menu-link" @click="(e) => onNavigateWithCountUpdate(e, navigate)">
                                                <span class="menu-text">
                                                    {{ $t('MENU.NEW') }}
                                                </span>
                                                <span v-if="counts.new !== null" class="menu-text ml-auto d-flex justify-content-end flex-grow-0 pr-9">{{ counts.new }}</span>
                                            </a>
                                        </li>
                                    </router-link>
                                    <router-link
                                        v-can:read="'applicationsStaffOwn'"
                                        to="/applications-in-work"
                                        v-slot="{ href, navigate, isExactActive }"
                                    >
                                        <li
                                            aria-haspopup="true"
                                            data-menu-toggle="hover"
                                            class="menu-item"
                                            :class="[
                                                isExactActive && 'menu-item-active'
                                            ]"
                                        >
                                            <a :href="href" class="menu-link" @click="(e) => onNavigateWithCountUpdate(e, navigate)">
                                                <span class="menu-text">
                                                    <span v-if="counts.in_work !== null && counts.in_work > 0" class="d-flex align-items-center">
                                                        <i class="fas fa-circle font-size-xs text-danger mr-2"></i>
                                                    </span>
                                                    {{ $t('MENU.IN_WORK') }}
                                                </span>
                                                <span v-if="counts.in_work !== null && counts.in_work > 0" class="menu-text ml-auto d-flex justify-content-end flex-grow-0 pr-9">{{ counts.in_work }}</span>
                                            </a>
                                        </li>
                                    </router-link>
                                    <router-link
                                        v-can:read="'applicationsStaffOwn'"
                                        to="/applications-completed"
                                        v-slot="{ href, navigate, isExactActive }"
                                    >
                                        <li
                                            aria-haspopup="true"
                                            data-menu-toggle="hover"
                                            class="menu-item"
                                            :class="[
                                                isExactActive && 'menu-item-active'
                                            ]"
                                        >
                                            <a :href="href" class="menu-link" @click="(e) => onNavigateWithCountUpdate(e, navigate)">
                                                <span class="menu-text">
                                                    {{ $t('MENU.COMPLETED') }}
                                                </span>
                                                <span v-if="counts.completed !== null" class="menu-text ml-auto d-flex justify-content-end flex-grow-0 pr-9">{{ counts.completed }}</span>
                                            </a>
                                        </li>
                                    </router-link>
                                    <router-link
                                        v-can:read="'applicationsStaffOwn'"
                                        to="/applications-with-errors"
                                        v-slot="{ href, navigate, isExactActive }"
                                    >
                                        <li
                                            aria-haspopup="true"
                                            data-menu-toggle="hover"
                                            class="menu-item"
                                            :class="[
                                                isExactActive && 'menu-item-active'
                                            ]"
                                        >
                                            <a :href="href" class="menu-link" @click="(e) => onNavigateWithCountUpdate(e, navigate)">
                                                <span class="menu-text">
                                                    {{ $t('MENU.WITH_ERRORS') }}
                                                </span>
                                                <span v-if="counts.with_errors !== null" class="menu-text ml-auto d-flex justify-content-end flex-grow-0 pr-9">{{ counts.with_errors }}</span>
                                            </a>
                                        </li>
                                    </router-link>
                                </ul>
                            </div>
                        </li>
                    </ul>
                </li>
            </router-link>
            <hr v-if="hasPermissionToViewApplications" v-can:read="'applicationsStaffOwn'">
            <router-link
                v-if="hasPermissionToViewApplications"
                v-slot="{ href, navigate, isActive, isExactActive }"
                to="/applications">
                <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                >
                    <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-icon far fa-file"/>
                        <span :class="{ 'menu-header': hasPermissionToViewApplications}"
                              class="menu-text">{{ $t('MENU.GENERAL_REGISTRY') }}</span>
                    </a>
                    <ul>
                        <li class="menu-item menu-item-submenu menu-item-open">
                            <div class="menu-submenu menu-submenu-classic menu-submenu-right ">
                                <ul class="menu-subnav">
                                    <router-link
                                        v-can:read="'beneficiaries'"
                                        v-slot="{ href, navigate, isExactActive }"
                                        to="/beneficiaries"
                                    >
                                        <li
                                            aria-haspopup="true"
                                            data-menu-toggle="hover"
                                            class="menu-item"
                                            :class="[
                                                isExactActive && 'menu-item-active'
                                            ]"
                                        >
                                            <a :href="href" class="menu-link" @click="navigate">
                                                <i class="menu-icon fas fa-people-arrows"></i>
                                                <span class="menu-text">
                                                    {{ $t('MENU.BENEFICIARIES') }}
                                                </span>
                                            </a>
                                        </li>
                                    </router-link>
                                </ul>
                            </div>
                        </li>
                        <li class="menu-item menu-item-submenu menu-item-open" v-can:read="'organisationsApplicationsRegister'">
                            <div class="menu-submenu menu-submenu-classic menu-submenu-right ">
                                <ul class="menu-subnav">
                                    <router-link
                                        v-slot="{ href, navigate, isExactActive }"
                                        to="/register-application">
                                        <li
                                            aria-haspopup="true"
                                            data-menu-toggle="hover"
                                            class="menu-item"
                                            :class="[
                                                isExactActive && 'menu-item-active'
                                            ]"
                                        >
                                            <a :href="href" class="menu-link" @click="navigate">
                                                <i class="fas fa-plus menu-icon"/>
                                                <span class="menu-text">
                                                    {{ $t('MENU.REGISTRY_ADD') }}
                                                </span>
                                            </a>
                                        </li>
                                    </router-link>
                                </ul>
                            </div>
                        </li>
                    </ul>
                </li>
            </router-link>
            <hr v-if="hasPermissionToViewApplications">
            <router-link v-can:read="'issuedDocument'" v-slot="{ href, navigate, isActive, isExactActive }" to="/issued-documents">
                <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item" :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
                    <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-icon far fa-folder"/>
                        <span class="menu-text">{{ $t('MENU.ISSUED_DOCUMENT') }}</span>
                    </a>
                </li>
            </router-link>
            <router-link v-can:read="'complain'" v-slot="{ href, navigate, isActive, isExactActive }" to="/complain">
                <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item" :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
                    <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-icon fas fa-exclamation-circle"/>
                        <span class="menu-text">{{ $t('MENU.MY_COMPLAINS') }}</span>
                    </a>
                </li>
            </router-link>
            <li
                v-if="canReadAnyRegisterResource"
                aria-haspopup="true"
                class="menu-item menu-item-submenu"
                :class="{
                    'menu-item-open': hasActiveRegisterRoute,
                    'menu-item-active': hasActiveRegisterRoute
                }"
            >
                <a href="#" class="menu-link menu-toggle" @click.prevent>
                    <i class="menu-icon fas fa-list-alt"/>
                    <span class="menu-text">{{ $t('MENU.REGISTERS') }}</span>
                    <span class="registers-menu-arrow">
                        <i class="fas fa-chevron-right"/>
                    </span>
                </a>
                <div class="menu-submenu menu-submenu-classic menu-submenu-right">
                    <ul class="menu-subnav">
                        <router-link
                            v-if="isSuperAdmin || hasPermissionToRegistersType"
                            v-slot="{ href, navigate, isActive, isExactActive }"
                            to="/registers-type/org"
                        >
                            <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item" :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
                                <a :href="href" class="menu-link" @click="navigate">
                                    <i class="menu-icon fas fa-list-alt"/>
                                    <span class="menu-text">{{ $t('MENU.SPECIAL_REGISTERS') }}</span>
                                </a>
                            </li>
                        </router-link>
                        <router-link v-can:read="'issuedDocumentStaff'" v-slot="{ href, navigate, isActive, isExactActive }" to="/issued-documents">
                            <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item" :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
                                <a :href="href" class="menu-link" @click="navigate">
                                    <i class="menu-icon far fa-folder"/>
                                    <span class="menu-text">{{ $t('MENU.ISSUED_DOCUMENT_STAFF') }}</span>
                                </a>
                            </li>
                        </router-link>
                        <!-- Remove condition once complains are ready to use -->
                        <router-link v-can:read="'complainStaff'" v-slot="{ href, navigate, isActive, isExactActive }" to="/complain">
                            <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item" :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
                                <a :href="href" class="menu-link" @click="navigate">
                                    <i class="menu-icon fas fa-exclamation-circle"/>
                                    <span class="menu-text">{{ $t('MENU.STAFF_COMPLAINS') }}</span>
                                </a>
                            </li>
                        </router-link>
                        <router-link v-can:read="'control'" v-slot="{ href, navigate, isActive, isExactActive }" to="/controls">
                            <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item" :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
                                <a :href="href" class="menu-link" @click="navigate">
                                    <i class="menu-icon fas fa-file-signature"/>
                                    <span class="menu-text">{{ $t('MENU.CONTROLS') }}</span>
                                </a>
                            </li>
                        </router-link>
                        <router-link v-can:read="'paymentRegistry'" v-slot="{ href, navigate, isActive, isExactActive }" to="/payments">
                            <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item" :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
                                <a :href="href" class="menu-link" @click="navigate">
                                    <i class="menu-icon far fa-credit-card"/>
                                    <span class="menu-text">{{ $t('MENU.PAYMENT_REGISTRY') }}</span>
                                </a>
                            </li>
                        </router-link>
                        <router-link v-slot="{ href, navigate, isActive, isExactActive }" to="/document-series-allocation" v-can:read="'documentSeriesAllocation'">
                            <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item" :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
                                <a :href="href" class="menu-link" @click="navigate">
                                    <i class="menu-icon fas fa-file"></i>
                                    <span class="menu-text">{{ $t('MENU.DOCUMENT_SERIES_ALLOCATION') }}</span>
                                </a>
                            </li>
                        </router-link>
                    </ul>
                </div>
            </li>
            <!-- END Root -->
            <!-- Organisation config -->
            <li v-if="viewStaffOrganisationAdministration || isSuperAdmin">
                <hr/>
            </li>
            <li class="menu-section" v-if="viewStaffOrganisationAdministration || isSuperAdmin">
                <h4 class="menu-text">{{ $t('MENU.ORGANISATION_CONFIG') }}</h4>
                <i class="menu-icon flaticon-more-v2"/>
            </li>
            <router-link
                v-can:read="'organisations'"
                v-slot="{ href, navigate, isActive, isExactActive }"
                to="/institutions"
            >
                <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                >
                    <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-icon fas fas fa-sitemap"></i>
                        <span class="menu-text">{{ $t('MENU.ORGANIZATION')}}</span>
                    </a>
                </li>
            </router-link>
            <router-link
                v-if="viewStaffOrganisationAdministration"
                v-slot="{ href, navigate, isActive, isExactActive }"
                :to="myInstitutionUrl"
            >
                <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                >
                    <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-icon fas fas fa-sitemap"></i>
                        <span class="menu-text">{{ $t('MENU.MY_ORGANIZATION')}}</span>
                    </a>
                </li>
            </router-link>
            <li v-if="isSuperAdmin">
                <hr/>
            </li>
            <!-- END Organisation config -->
            <!-- System config -->
            <li class="menu-section" v-if="isSuperAdmin">
                <h4 class="menu-text">{{ $t('MENU.SYSTEM_CONFIG') }}</h4>
                <i class="menu-icon flaticon-more-v2"/>
            </li>
            <router-link
                v-can:read="'processEditor'"
                v-slot="{ href, navigate, isActive, isExactActive }"
                to="/process-editor"
            >
                <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                >
                    <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-icon fas fa-cogs"></i>
                        <span class="menu-text">{{ $t('MENU.PROCESS_MANAGEMENT')}}</span>
                    </a>
                </li>
            </router-link>
            <router-link
                v-can:read="'accounts'"
                v-slot="{ href, navigate, isActive, isExactActive }"
                to="/accounts"
            >
                <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                >
                    <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-icon fas fas fa-users"></i>
                        <span class="menu-text">{{ $t('MENU.ACCOUNTS') }}</span>
                    </a>
                </li>
            </router-link>
            <router-link
                v-if="!hasPermissionToViewApplications" v-can:read="'beneficiaries'"
                v-slot="{ href, navigate, isActive, isExactActive }"
                to="/beneficiaries"
            >
                <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                >
                    <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-icon fas fa-people-arrows"></i>
                        <span class="menu-text">{{ $t('MENU.BENEFICIARIES') }}</span>
                    </a>
                </li>
            </router-link>
            <router-link
                v-can:read="'taxCategory'"
                v-slot="{ href, navigate, isActive, isExactActive }"
                to="/tax-category"
            >
                <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                >
                    <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-icon fas fas fa-hand-holding-usd"></i>
                        <span class="menu-text">{{ $t('MENU.TAX_CATEGORY') }}</span>
                    </a>
                </li>
            </router-link>
            <router-link
                v-can:read="'complainType'"
                v-slot="{ href, navigate, isActive, isExactActive }"
                to="/complain-type"
            >
                <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                >
                    <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-icon fas fas fa-exclamation-circle"></i>
                        <span class="menu-text">{{ $t('MENU.COMPLAIN_TYPE') }}</span>
                    </a>
                </li>
            </router-link>
            <router-link
                v-slot="{ href, navigate, isActive, isExactActive }"
                to="/application-type"
                v-can:read="'applicationType'"
            >
                <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                >
                    <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-icon fas fas fa-exclamation-circle"></i>
                        <span class="menu-text">{{ $t('MENU.APPLICATION_TYPE') }}</span>
                    </a>
                </li>
            </router-link>
            <router-link
                v-slot="{ href, navigate, isActive, isExactActive }"
                to="/document-series-type"
                v-can:read="'documentSeriesType'"
            >
                <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                >
                    <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-icon fas fas fa-exclamation-circle"></i>
                        <span class="menu-text">{{ $t('MENU.DOCUMENT_SERIES_TYPE') }}</span>
                    </a>
                </li>
            </router-link>
            <router-link
                v-if="isSuperAdmin"
                v-slot="{ href, navigate, isActive, isExactActive }"
                to="/register-type"
            >
                <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                >
                    <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-icon fas fas fa-list-alt"></i>
                        <span class="menu-text">{{ $t('MENU.REGISTERS_TYPE') }}</span>
                    </a>
                </li>
            </router-link>
            <router-link
                v-slot="{ href, navigate, isActive, isExactActive }"
                to="/control-type"
                v-can:read="'controlType'"
            >
                <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                >
                    <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-icon fas fas fa-exclamation-circle"></i>
                        <span class="menu-text">{{ $t('MENU.CONTROL_TYPE') }}</span>
                    </a>
                </li>
            </router-link>
            <router-link
                v-can:read="'forms'"
                v-slot="{ href, navigate, isActive, isExactActive }"
                to="/forms">
                <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                >
                    <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-icon fab fa-wpforms"/>
                        <span class="menu-text">{{ $t('MENU.FORMS') }}</span>
                    </a>
                </li>
            </router-link>
            <router-link
                v-if="viewDocumentsTemplates"
                v-slot="{ href, navigate, isActive, isExactActive }"
                to="/document-template">
                <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                >
                    <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-icon far fa-copy"/>
                        <span class="menu-text">{{ $t('MENU.DOCUMENT_TEMPLATE') }}</span>
                    </a>
                </li>
            </router-link>
            <router-link
                v-can:read="'responseTemplates'"
                v-slot="{ href, navigate, isActive, isExactActive }"
                to="/response-templates"
            >
                <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                >
                    <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-icon fas fas fa-exclamation-circle"></i>
                        <span class="menu-text">{{ $t('MENU.RESPONSE_TEMPLATES') }}</span>
                    </a>
                </li>
            </router-link>
            <router-link
                v-can:read="'notificationsTemplate'"
                v-slot="{ href, navigate, isActive, isExactActive }"
                to="/notifications-templates"
            >
                <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                >
                    <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-icon far fa-bell"/>
                        <span class="menu-text">{{ $t('MENU.NOTIFICATIONS') }}</span>
                    </a>
                </li>
            </router-link>
            <router-link
                v-slot="{ href, navigate, isActive, isExactActive }"
                to="/responsibilities"
                v-can:read="'responsibility'"
            >
                <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                >
                    <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-icon  fas fa-people-carry"></i>
                        <span class="menu-text">{{ $t('MENU.RESPONSIBILITIES') }}</span>
                    </a>
                </li>
            </router-link>
            <router-link
                v-can:read="'permissions'"
                v-slot="{ href, navigate, isActive, isExactActive }"
                to="/permissions">
                <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                >
                    <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-icon fas fa-user-lock"/>
                        <span class="menu-text">{{ $t('MENU.PERMISSIONS') }}</span>
                    </a>
                </li>
            </router-link>
            <router-link
                v-can:read="'metadataMapping'"
                v-slot="{ href, navigate, isActive, isExactActive }"
                to="/metadata-mapping">
                <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                >
                    <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-icon fas fa-map-signs"/>
                        <span class="menu-text">{{ $t('MENU.METADATA_MAPPING') }}</span>
                    </a>
                </li>
            </router-link>
            <router-link
                v-if="false"
                v-slot="{ href, navigate, isActive, isExactActive }"
                to="/payments">
                <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                >
                    <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-icon far fa-credit-card"/>
                        <span class="menu-text">{{ $t('MENU.PAYMENTS') }}</span>
                    </a>
                </li>
            </router-link>
            <router-link
                v-if="false"
                v-slot="{ href, navigate, isActive, isExactActive }"
                to="/documents">
                <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                >
                    <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-icon far fa-folder"/>
                        <span class="menu-text">{{ $t('MENU.DOCUMENTS') }}</span>
                    </a>
                </li>
            </router-link>
            <router-link
                v-can:read="'decisionPurpose'"
                v-slot="{ href, navigate, isActive, isExactActive }"
                to="/decision-purpose-list"
            >
                <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                >
                    <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-icon fas fa-list"></i>
                        <span class="menu-text">{{ $t('MENU.PURPOSE_LIST') }}</span>
                    </a>
                </li>
            </router-link>
            <router-link
                v-can:read="'decisionTarget'"
                v-slot="{ href, navigate, isActive, isExactActive }"
                to="/decision-target-list"
            >
                <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                >
                    <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-icon fas fa-list"></i>
                        <span class="menu-text">{{ $t('MENU.TARGET_LIST') }}</span>
                    </a>
                </li>
            </router-link>
            <router-link
                v-can:read="'systemSettings'"
                v-slot="{ href, navigate, isActive, isExactActive }"
                to="/system-settings"
            >
                <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                >
                    <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-icon fas fa-cogs"></i>
                        <span class="menu-text">{{ $t('MENU.SYSTEM_SETTINGS') }}</span>
                    </a>
                </li>
            </router-link>
            <li>
                <hr/>
            </li>
            <!-- END System config -->
            <!-- Translations -->
            <li class="menu-section" v-if="isSuperAdmin">
                <h4 class="menu-text">{{ $t('MENU.TRANSLATIONS_SECTION') }}</h4>
                <i class="menu-icon flaticon-more-v2"/>
            </li>
            <router-link
                v-can:read="'translations'"
                v-slot="{ href, navigate }"
                to="/translations"
            >
                <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[$route.path === '/translations' && 'menu-item-active']"
                >
                    <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-icon fas fa-language"></i>
                        <span class="menu-text">{{ $t('MENU.TRANSLATIONS') }}</span>
                    </a>
                </li>
            </router-link>
            <router-link
                v-can:read="'glossary'"
                v-slot="{ href, navigate, isActive, isExactActive }"
                to="/translations/glossary"
            >
                <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                >
                    <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-icon fas fa-book"></i>
                        <span class="menu-text">{{ $t('MENU.TRANSLATIONS_GLOSSARY') }}</span>
                    </a>
                </li>
            </router-link>
            <router-link
                v-can:read="'translations'"
                v-slot="{ href, navigate, isActive, isExactActive }"
                to="/translations/dashboard"
            >
                <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                >
                    <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-icon fas fa-chart-pie"></i>
                        <span class="menu-text">{{ $t('MENU.TRANSLATIONS_DASHBOARD') }}</span>
                    </a>
                </li>
            </router-link>
            <li v-if="isSuperAdmin">
                <hr/>
            </li>
            <!-- END Translations -->
            <li class="menu-section" v-if="isStaff">
                <h4 class="menu-text">{{ $t('MENU.EXTERNAL_APPS') }}</h4>
                <i class="menu-icon flaticon-more-v2"/>
            </li>
            <router-link
                v-slot="{ href, isActive, isExactActive }"
                to="/atlas"
            >
                <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                >
                    <a :href="href" class="menu-link" @click.prevent="navigateTo('atlas')">
                        <i class="menu-icon fas fa-globe-europe"/>
                        <span class="menu-text">{{ $t('MENU.ATLAS') }}</span>
                    </a>
                </li>
            </router-link>
            <router-link
                v-if="isStaff"
                v-can:read="'archive'"
                v-slot="{ href, isActive, isExactActive }"
                to="/archive-dashboard"
            >
                <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                >
                    <a :href="href" class="menu-link" @click.prevent="navigateTo('archive')">
                        <i class="menu-icon fas fa-archive"/>
                        <span class="menu-text">{{ $t('MENU.ARCHIVE') }}</span>
                    </a>
                </li>
            </router-link>
            <router-link
                v-if="hasPermissionToViewEfactura"
                v-slot="{ href, navigate, isActive, isExactActive }"
                to="/efactura"
            >
                <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                >
                    <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-icon fas fa-file-invoice"/>
                        <span class="menu-text">{{ $t('MENU.EFACTURA') }}</span>
                    </a>
                </li>
            </router-link>
            <!-- Real Estate Register Menu Item -->
            <router-link
                v-if="hasPermissionToRealEstateRegister"
                v-slot="{ href, navigate, isActive, isExactActive }"
                to="/real-estate-register"
            >
                <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                >
                    <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-icon fas fa-building"/>
                        <span class="menu-text">{{ $t('MENU.REAL_ESTATE_REGISTER') }}</span>
                    </a>
                </li>
            </router-link>
            <router-link
                v-if="isStaff"
                v-slot="{ href, navigate, isActive, isExactActive }"
                to="/useful-links"
                v-can:read="'documentSeriesAllocation'"
            >
                <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                >
                    <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-icon fas fa-list"></i>
                        <span class="menu-text">{{ $t('MENU.USEFUL_LINKS') }}</span>
                    </a>
                </li>
            </router-link>                        
            <li v-if="!isStaff">
                <hr/>
            </li>
             <!-- Help Section -->
            <li class="menu-section" v-if="!isStaff">
                <h4 class="menu-text">{{ $t('MENU.HELP') }}</h4>
                <i class="menu-icon flaticon-more-v2"/>
            </li>
            <router-link
                v-if="false"
                v-slot="{ href, navigate, isActive, isExactActive }"
                to="/manual">
                <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                >
                    <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-icon flaticon2-open-text-book"/>
                        <span class="menu-text">{{ $t('MENU.MANUAL') }}</span>
                    </a>
                </li>
            </router-link>
            <router-link
                v-if="!isStaff"
                v-slot="{ href, isActive, isExactActive }"
                to="/faq">
                <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                >
                    <a :href="href" class="menu-link" @click.prevent="navigateTo('faq')">
                        <i class="menu-icon far fa-question-circle"/>
                        <span class="menu-text">{{ $t('MENU.FAQ') }}</span>
                    </a>
                </li>
            </router-link>
            <li v-if="!isStaff" class="menu-item">
                <a :href="`tel:${supportPhone}`" class="menu-link" @click.prevent="openPhone">
                    <i class="menu-icon fas fa-phone"/>
                    <span class="menu-text">{{ supportPhone }}</span>
                </a>
            </li>
            <router-link
                v-if="!isStaff"
                v-slot="{ href, isActive, isExactActive }"
                to="/applications-details">
                <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                >
                    <a :href="href" class="menu-link" @click.prevent="navigateTo('applications_details')">
                        <i class="menu-icon fas fa-th-list"/>
                        <span class="menu-text">{{ $t('MENU.APPLICATIONS_DETAILS') }}</span>
                    </a>
                </li>
            </router-link>
            <router-link
                v-if="false"
                v-slot="{ href, navigate, isActive, isExactActive }"
                to="/gdpr">
                <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                >
                    <a :href="href" class="menu-link" @click="navigate">
                        <i class="menu-icon fas fa-book"/>

                        <span class="menu-text">GDPR</span>
                    </a>
                </li>
            </router-link>
        </ul>
    </div>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex';
    import AppConfig from '@/config/app.config.json';
    import { ApplicationTypePermissions } from "@/modules/application-type/application-type-permissions";
    import { InstitutionsPermissions } from "@/modules/administrator/institutions-permissions";
    import { ApplicationsPermissions } from '@/modules/applications/applications-permissions';
    import { DashboardPermissions } from '@/modules/dashboard/dashboard-permissions';
    import { DocumentTemplatePermissions } from '@/modules/document-template/document-template-permissions';
    import { InternalDocumentsPermissions } from '@/modules/internal-documents/internal-documents-permissions';
    import { RealEstateRegisterPermissions } from '@/modules/real-estate-register/real-estate-register-permissions';
    import { EfacturaPermissions } from '@/modules/efactura/efactura-permissions';
    import PermissionChecker from '@/security/permission-checker';
    import Permissions from '@/security/permissions';
    import { Subject, debounceTime } from 'rxjs';

    const LANDING_PAGES =  {
        faq: '/intrebari-frecvente',
        applications_details: '/'
    }
    export default {
        name: 'MenuGU',
        data() {
            return {
                supportPhone: AppConfig.find(c => c.key === 'SUPPORT_PHONE')?.value,
                counts: {
                    draft: null,
                    submitted: null,
                    sign_pending: null,
                    clarifications: null,
                    finalized: null,
                    assigned: null,
                    assigned_clarifications: null,
                    to_review: null,
                    new: null,
                    in_work: null,
                    completed: null,
                    with_errors: null,
                },
                recalc$: null,
                recalcSub: null
            }
        },
        computed: {
            ...mapGetters({
                currentUser: 'auth/currentUser',
                accountDetails: 'auth/accountDetails',
                appConfig: "shared/appConfig",
                isStaff: 'auth/isStaff',
                isSimpleStaff: 'auth/isSimpleStaff',
                isAdminStaff: 'auth/isAdminStaff',
                isSuperAdmin: 'auth/isSuperAdmin'
            }),
            hasPermissionToApplicationType() {
                return new ApplicationTypePermissions(this.currentUser).read;
            },
            hasPermissionToOwnOrganisation() {
                return new InstitutionsPermissions(this.currentUser).viewOwnOrganisation;
            },
            myInstitutionUrl() {
                return `/institution?id=${this.accountDetails?.organisation_id}&tab=institution-details`;
            },
            hasPermissionToOwnStaffApplications() {
                return new ApplicationsPermissions(this.currentUser).readOwnStaff;
            },
            hasPermissionToViewOrgApplications() {
                return new ApplicationsPermissions(this.currentUser).readStaff;
            },
            hasPermissionToViewApplications() {
                return this.hasPermissionToViewOrgApplications || this.hasPermissionToOwnStaffApplications
            },
            hasPermissionsToViewDashboard() {
                return new DashboardPermissions(this.currentUser).view;
            },
            hasPermissionsToViewReports() {
                return new DashboardPermissions(this.currentUser).viewReports;
            },
            viewStaffOrganisationAdministration() {
                return this.hasPermissionToOwnOrganisation && this.isAdminStaff;
            },
            hasPermissionsToReadDocumentsTemplates() {
                return new DocumentTemplatePermissions(this.currentUser).read;
            },
            viewDocumentsTemplates() {
                return this.hasPermissionsToReadDocumentsTemplates && this.isSuperAdmin;
            },
            hasPermissionToInternalDocuments() {
                return new InternalDocumentsPermissions(this.currentUser).read;
            },
            hasPermissionToRealEstateRegister() {
                return new RealEstateRegisterPermissions(this.currentUser).read;
            },
            hasPermissionToRegistersType() {
                const perm = new PermissionChecker(this.accountDetails).match(Permissions.values.registersTypeRead);
                return perm;
            },
            hasPermissionToViewEfactura() {
                return new EfacturaPermissions(this.currentUser).read && !this.isSuperAdmin;
            },
            canReadAnyRegisterResource() {
                const permissionChecker = new PermissionChecker(this.accountDetails);
                const registerPermissions = [
                    Permissions.values.registersTypeRead,
                    Permissions.values.issuedDocumentStaffRead,
                    Permissions.values.complainStaffRead,
                    Permissions.values.controlRead,
                    Permissions.values.paymentRegistryRead,
                    Permissions.values.documentSeriesAllocationRead
                ];

                return this.isSuperAdmin || registerPermissions.some(permission => permissionChecker.match(permission));
            },
            hasActiveRegisterRoute() {
                const registerRoutes = [
                    '/registers-type',
                    '/registers-type/org',
                    '/issued-documents',
                    '/complain',
                    '/controls',
                    '/payments',
                    '/document-series-allocation'
                ];

                return registerRoutes.some(route =>
                    this.$route.path === route || this.$route.path.startsWith(`${route}/`)
                );
            },
        },
        methods: {
            ...mapActions({
                getApplicationsCount: 'getApplicationsCount'
            }),
            onNavigateWithCountUpdate(e, navigate) {
                this.recalc$.next();
                navigate(e);
            },
            hasActiveChildren(match) {
                return this.$route.path.indexOf(match) !== -1;
            },
            createRequest() {
                this.$router.push({ name: 'applicationNew'})
            },
            openPhone() {
                window.location.href = `tel:${this.supportPhone}`;
            },
            navigateTo(item) {
                if (LANDING_PAGES[item]) {
                    window.open(`${window.VUE_APP_LANDING_PAGE_URL}${LANDING_PAGES[item]}`, '_blank');
                }
                this.$emit('navigate', item);
            },
            async getCounts() {
                // Determine which counts to fetch based on user type
                const citizenCountKeys = ['draft', 'submitted', 'sign_pending', 'clarifications', 'finalized'];
                const staffCountKeys = ['assigned', 'assigned_clarifications', 'to_review', 'new', 'in_work', 'completed', 'with_errors'];
                
                // Get only the relevant keys based on user type
                const menuEntries = this.isStaff ? staffCountKeys : citizenCountKeys;
                
                const requests = menuEntries.map(menuKey =>
                    this.getApplicationsCount({
                        params: {
                            skip: 0,
                            limit: 1, // query used only to display counts on side menu, so we should minimize data retrived on UI, and use pagination total count
                            pagination: true,
                            [menuKey]: true
                        }
                }))

                const counts = await Promise.all(requests)
                menuEntries.forEach((menuKey, index) => {
                    this.$set(this.counts, menuKey, counts[index])
                })
            }      
        },
        async created() {
            if (this.isSimpleStaff && this.hasPermissionToOwnStaffApplications) {
                await this.getCounts();  
                this.recalc$ = new Subject()
                this.recalcSub = this.recalc$
                .pipe(debounceTime(1000))
                .subscribe((_) => {
                    this.getCounts();
                }) 
            }
            // Load counts for citizen applications
            if (!this.isStaff) {
                await this.getCounts();
            }

            // Listen for global refresh events
            this.$root.$on('refresh-menu-counts', () => {
                if (this.recalc$) {
                    this.recalc$.next();
                } else {
                    this.getCounts();
                }
            });
        },
        beforeDestroy() {
            this.$root.$off('refresh-menu-counts');
            if (this.recalcSub) {
                this.recalcSub.unsubscribe();
            }
        }
    };
</script>
